import { useContext } from 'react'
import ActiveNavbarContext from '../context/ActiveNavBarProvider';

const useActiveNavbar = () => {
    return useContext(ActiveNavbarContext);
}

export default useActiveNavbar